import { COMPANY_DOCTORS, CONDUCTORS, JOBTITLES } from '../@types/const';

export const removeAllCachedData = () => {
    localStorage.removeItem(CONDUCTORS);
    localStorage.removeItem(COMPANY_DOCTORS);
    localStorage.removeItem(JOBTITLES);
};
